import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, X } from "lucide-react";
import { adminShop, assetUrl, errMsg } from "../../lib/shopApi";
import { btn } from "./shared";

export const PhotoManager = ({ product, setProduct, passcode }) => {
  const [uploading, setUploading] = useState(false);
  const images = product.images || [];
  const unused = (product.printful_mockups || []).filter((m) => !images.includes(m));

  const upload = async (e) => {
    const files = [...e.target.files];
    e.target.value = "";
    setUploading(true);
    try {
      let saved;
      for (const f of files) saved = await adminShop.uploadImage(product.id, f, passcode);
      if (saved) setProduct({ ...product, images: saved.images });
      toast("Photo added — remember to save.");
    } catch (err) { toast.error(errMsg(err, "Upload failed.")); }
    finally { setUploading(false); }
  };

  const move = (i) => {
    const next = [...images];
    [next[i - 1], next[i]] = [next[i], next[i - 1]];
    setProduct({ ...product, images: next });
  };

  return (
    <div data-testid="admin-shop-photos">
      <p className="text-[10px] uppercase tracking-[0.25em] text-[#6D5A50] mb-2">Photos (first one is the cover)</p>
      <div className="flex flex-wrap gap-3">
        {images.map((src, i) => (
          <div key={src} className="relative w-24 h-24 rounded border border-[#E7DFD5] bg-white overflow-hidden" data-testid={`admin-shop-photo-${i}`}>
            <img src={assetUrl(src)} alt="" className="w-full h-full object-contain" />
            <button type="button" aria-label="Remove photo" onClick={() => setProduct({ ...product, images: images.filter((x) => x !== src) })} className="absolute top-1 right-1 bg-white/90 rounded-full p-0.5" data-testid={`admin-shop-photo-remove-${i}`}><X size={12} /></button>
            {i > 0 && <button type="button" aria-label="Move earlier" onClick={() => move(i)} className="absolute bottom-1 left-1 bg-white/90 rounded-full p-0.5" data-testid={`admin-shop-photo-left-${i}`}><ArrowLeft size={12} /></button>}
          </div>
        ))}
        <label className={`${btn.ghost} self-center cursor-pointer`} data-testid="admin-shop-photo-upload-label">
          {uploading ? "Uploading…" : "Upload photos"}
          <input type="file" accept="image/*,.heic,.heif" multiple className="hidden" onChange={upload} data-testid="admin-shop-photo-upload" />
        </label>
      </div>
      {unused.length > 0 && (
        <div className="mt-3">
          <p className="text-xs text-[#8D7B6E] italic mb-2">Printful mockups you can add back:</p>
          <div className="flex flex-wrap gap-2">
            {unused.map((m) => (
              <button key={m} type="button" onClick={() => setProduct({ ...product, images: [...images, m] })} className="w-14 h-14 rounded border border-dashed border-[#D9CBB8] bg-white overflow-hidden" data-testid="admin-shop-mockup-add">
                <img src={m} alt="" className="w-full h-full object-contain opacity-80" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
